import { render, staticRenderFns } from "./CanteenGeneratePoster.vue?vue&type=template&id=2cdff033&scoped=true&"
import script from "./CanteenGeneratePoster.vue?vue&type=script&lang=js&"
export * from "./CanteenGeneratePoster.vue?vue&type=script&lang=js&"
import style0 from "./CanteenGeneratePoster.vue?vue&type=style&index=0&id=2cdff033&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdff033",
  null
  
)

export default component.exports